import { ApiContext } from "@/contexts"
import React, { useContext } from "react"

export const ApiProvider = ({ children, apiBase, useApiPathBuilder }) => {
  const { base } = useContext(ApiContext)
  const current = useApiPathBuilder(apiBase)

  return <ApiContext.Provider value={{ base, current }}>{children}</ApiContext.Provider>
}
